import { render, staticRenderFns } from "./RolesListView.vue?vue&type=template&id=590e4fa0&scoped=true&"
import script from "./RolesListView.vue?vue&type=script&lang=js&"
export * from "./RolesListView.vue?vue&type=script&lang=js&"
import style0 from "./RolesListView.vue?vue&type=style&index=0&id=590e4fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e4fa0",
  null
  
)

export default component.exports